import { FC } from 'react';

import { findSelectedOption } from '../components/form/ControlledSelect';
import { Option } from '../types';
import { WorkflowStepFormFieldTypeahead } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const TypeaheadFieldToBlock: FieldToBlock<
  'typeahead',
  WorkflowStepFormFieldTypeahead
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'typeahead',
  componentProps: {
    options: field.options,
    isMulti: field.isMulti,
    size: 'sm',
  },
});

type TypeaheadFieldValueProps = FieldValueProps<'typeahead'>;

export const TypeaheadFieldValue: FC<TypeaheadFieldValueProps> = ({
  field,
}) => {
  // TODO: this does not currently support "groups"
  const selectedOption = findSelectedOption(
    field.options,
    undefined,
    field.value,
    field.isMulti,
  );

  if (field.isMulti) {
    const labels = (selectedOption as Array<Option>).map((o) => o.label);
    return <>{labels.length > 0 ? labels.join(', ') : '–'}</>;
  }

  return <>{((selectedOption as Option)?.label || field.value) ?? '–'}</>;
};
